export const CONTEXT_TYPE = {
  USERS: 'users',
  ROTATIONS: 'rotations',
  METRICS: 'metrics',
  SYNONYMS: 'synonyms',
};

import { useUploadUsers } from './users';
import { useUploadRotationTimeSlots } from './rotation';
import { useUploadMetricRecords } from './quality-metric';
import { useUploadSynonyms } from './synonyms';

export function useUploadContextFactory({ contextType = CONTEXT_TYPE.USERS }) {
  const usersContext = useUploadUsers();
  const rotationsContext = useUploadRotationTimeSlots();
  const metricsContext = useUploadMetricRecords();
  const synonymsContext = useUploadSynonyms();

  if (contextType === CONTEXT_TYPE.USERS) {
    return usersContext;
  }

  if (contextType === CONTEXT_TYPE.ROTATIONS) {
    return rotationsContext;
  }

  if (contextType === CONTEXT_TYPE.METRICS) {
    return metricsContext;
  }

  if (contextType === CONTEXT_TYPE.SYNONYMS) {
    return synonymsContext;
  }
}
